export type WeekFilterKeys = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';
export const MAX_WEEKDAY = 8;

export interface WeekFilter {
  mon: boolean;
  tue: boolean;
  wed: boolean;
  thu: boolean;
  fri: boolean;
  sat: boolean;
  sun: boolean;
  d1: boolean;
  d2: boolean;
}


export interface OperationModeInterval {
  days: WeekFilter;
  start: string;
  end: string;
}
